<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask
            id="mask0_8560_37796"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="55"
            y="30"
            width="42"
            height="58">
            <path
                d="M96.8573 83.1716C78.3396 61.8119 78.0605 30.6831 78.0605 30.6831L74.9535 33.1895C74.9535 33.1895 76.5465 38.1178 76.5465 40.8724C76.5465 43.6269 77.4148 45.2198 74.8069 45.2198C72.199 45.2198 69.7348 46.8128 69.7348 46.8128C69.7348 46.8128 67.4145 55.0736 67.4145 60.5827C67.4145 66.0917 68.2829 71.7418 67.1241 73.7717L55.8184 81.8887L60.6818 87.8433C60.6818 87.8433 81.9061 80.5834 91.0381 84.0625L96.8545 83.1744L96.8573 83.1716Z"
                fill="white" />
        </mask>
        <g mask="url(#mask0_8560_37796)">
            <path
                d="M69.4472 57.9717C71.0479 57.9717 72.3455 56.6741 72.3455 55.0734C72.3455 53.4727 71.0479 52.175 69.4472 52.175C67.8465 52.175 66.5488 53.4727 66.5488 55.0734C66.5488 56.6741 67.8465 57.9717 69.4472 57.9717Z"
                class="primary-fill primary-stroke"
                stroke-width="0.986784"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M79.0116 50.4356C80.6123 50.4356 81.9099 49.1379 81.9099 47.5372C81.9099 45.9365 80.6123 44.6389 79.0116 44.6389C77.4109 44.6389 76.1133 45.9365 76.1133 47.5372C76.1133 49.1379 77.4109 50.4356 79.0116 50.4356Z"
                class="primary-fill primary-stroke"
                stroke-width="0.986784"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M78.1054 65.3386C79.7061 65.3386 81.0037 64.041 81.0037 62.4403C81.0037 60.8396 79.7061 59.542 78.1054 59.542C76.5047 59.542 75.207 60.8396 75.207 62.4403C75.207 64.041 76.5047 65.3386 78.1054 65.3386Z"
                class="primary-fill primary-stroke"
                stroke-width="0.986784"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M86.6561 72.7283C88.2568 72.7283 89.5545 71.4307 89.5545 69.83C89.5545 68.2293 88.2568 66.9316 86.6561 66.9316C85.0554 66.9316 83.7578 68.2293 83.7578 69.83C83.7578 71.4307 85.0554 72.7283 86.6561 72.7283Z"
                class="primary-fill primary-stroke"
                stroke-width="0.986784"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M70.0253 76.667C71.626 76.667 72.9236 75.3694 72.9236 73.7687C72.9236 72.168 71.626 70.8704 70.0253 70.8704C68.4246 70.8704 67.127 72.168 67.127 73.7687C67.127 75.3694 68.4246 76.667 70.0253 76.667Z"
                class="primary-fill primary-stroke"
                stroke-width="0.986784"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M60.7753 86.253C62.376 86.253 63.6736 84.9553 63.6736 83.3546C63.6736 81.7539 62.376 80.4563 60.7753 80.4563C59.1746 80.4563 57.877 81.7539 57.877 83.3546C57.877 84.9553 59.1746 86.253 60.7753 86.253Z"
                class="primary-fill primary-stroke"
                stroke-width="0.986784"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M82.8065 82.4861C84.4072 82.4861 85.7049 81.1885 85.7049 79.5878C85.7049 77.9871 84.4072 76.6895 82.8065 76.6895C81.2058 76.6895 79.9082 77.9871 79.9082 79.5878C79.9082 81.1885 81.2058 82.4861 82.8065 82.4861Z"
                class="primary-fill primary-stroke"
                stroke-width="0.986784"
                stroke-linecap="round"
                stroke-linejoin="round" />
        </g>
        <path
            d="M28.8927 91.5791C24.923 94.5253 17.2317 97.3109 26.6175 107.306C37.2155 118.594 45.1662 86.3801 78.917 83.6651C98.554 82.0862 107.297 90.8968 75.982 94.0489C46.7394 96.9923 50.7486 80.7075 62.1079 59.2041"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M29.5312 90.2991C29.5312 90.2991 46.7972 73.6872 49.5066 75.7595C51.5986 77.3581 56.8962 83.0476 59.2053 85.5625C59.7691 86.1771 59.6056 87.1554 58.8726 87.553L56.4676 88.8584"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M46.0488 78.5198L55.0878 87.4459"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M50.275 83.2563L27.2266 103.999"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.9199 25.8312C65.9199 25.8312 80.3382 26.6685 88.3425 14.5903C92.3516 8.54272 80.8993 15.8534 78.2293 19.3663"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M82.6933 15.3177C82.6933 15.3177 80.0572 8.97122 74.159 12.6223C68.2609 16.2734 69.5972 20.4743 71.5624 22.7214"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M83.6136 20.5391C83.6136 20.5391 84.7357 21.7401 84.8541 22.3294C84.9725 22.9158 83.4952 23.006 83.4952 24.0605C83.4952 25.1149 82.8636 27.8695 80.828 27.0406C79.7961 26.6205 78.8601 26.0425 78.2793 24.9627"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M20.1838 105.279C21.1741 105.279 21.9769 104.476 21.9769 103.486C21.9769 102.495 21.1741 101.692 20.1838 101.692C19.1934 101.692 18.3906 102.495 18.3906 103.486C18.3906 104.476 19.1934 105.279 20.1838 105.279Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M26.8439 113.988C27.8342 113.988 28.637 113.185 28.637 112.194C28.637 111.204 27.8342 110.401 26.8439 110.401C25.8536 110.401 25.0508 111.204 25.0508 112.194C25.0508 113.185 25.8536 113.988 26.8439 113.988Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.6938 26.6404C79.6938 26.6404 77.8499 28.6957 78.0642 30.6806C78.0642 30.6806 78.3433 61.8094 96.861 83.169"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M74.3418 32.017C74.3418 32.017 78.1536 41.6424 75.9912 44.5774C73.8287 47.5124 64.0172 42.2824 61.3191 41.6424C59.6387 41.2449 65.9513 31.4475 70.1212 31.4475"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.4898 43.3425C65.4898 43.3425 63.9448 59.0972 64.7173 64.8093C64.7173 64.8093 62.1348 69.1653 62.1348 70.0054C62.1348 70.8456 62.9778 72.1707 62.9778 72.1707"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M64.8985 70.7298C64.8985 70.7298 61.05 72.1733 61.7718 73.256C62.4936 74.3386 63.3337 74.8179 63.3337 74.8179C63.3337 74.8179 65.9783 72.413 66.0996 71.57C66.2208 70.727 65.8599 70.3689 64.8985 70.727V70.7298Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.0195 73.256C65.0195 73.256 66.1022 75.4213 66.8239 73.9778C67.5457 72.5342 67.7853 68.0853 67.4245 65.4407C67.0636 62.7961 67.9066 49.0882 70.3115 44.8789"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M62.1329 74.0959L53.4746 82.1537"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.5098 86.3069C85.8312 87.085 85.9834 89.1742 85.9101 90.1074C85.6113 93.8403 89.9757 103.218 91.766 105.755C93.5563 108.292 93.2574 113.965 94.3034 115.011"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M91.168 86.3462C91.168 86.3462 93.8548 107.097 98.1854 108.591C102.516 110.083 107.441 109.189 107.74 110.381"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.6067 86.304C77.2881 87.2851 76.6707 88.7343 75.6416 89.4814C74.0007 90.6768 60.947 105.425 61.9929 107.813C63.0389 110.201 69.0104 114.382 68.7115 114.98C68.4127 115.578 55.1249 113.04 54.6795 111.845C54.2312 110.649 56.4698 108.56 57.8146 105.724C58.9311 103.367 63.2617 92.6927 67.5528 88.3283"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M109.567 110.655C109.203 112.014 96.781 116.641 95.1486 116.187C93.5161 115.733 94.3027 115.011 94.3027 115.011C95.3487 116.054 108.039 111.577 107.74 110.382C107.74 110.382 109.931 109.293 109.567 110.652V110.655Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M103.374 109.479C103.374 109.479 102.807 112.316 103.729 112.953L100.396 114.23C100.396 114.23 99.4038 110.542 100.608 109.127L103.374 109.482V109.479Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M68.7106 114.98C68.7106 114.98 69.9258 115.984 68.2257 116.41C66.5256 116.835 55.8909 115.772 54.9689 115.772C54.047 115.772 53.4803 114.653 54.7575 114.794C56.0347 114.935 67.0725 115.679 68.7134 114.98H68.7106Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M66.2395 112.44C66.2395 112.44 64.7509 113.362 64.4661 114.636L60.7051 114.946C60.7051 114.946 61.0378 111.104 63.829 110.311L66.2395 112.437V112.44Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.2599 24.5767C73.6294 36.6408 61.2551 41.4676 54.4519 34.9351C47.6488 28.4026 66.1044 34.1231 71.7686 25.3915C71.7686 25.3915 72.8258 25.1716 74.1453 24.8643C74.9855 24.6697 76.3529 24.1425 76.2599 24.5767Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M31.9375 89.9439C31.9375 89.9439 39.781 83.0307 43.3701 80.3721"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M30.5547 103.784L50.3609 86.2393"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
